

<app-loader [show]="skeleton"></app-loader>
<section [class.d-none]="skeleton" class="section">
  <div class="row">
  <div class="col-md-3 bg-white rounded">
    <div class="pl-3 pr-5">
      <app-navbar [step]="0">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <app-breadcrumb [title]="'Dashboard'"></app-breadcrumb>
  <div *ngIf="!profile">
    <div class="row">
      <div class="col-md-12 text-center">
        <h4 class="description text-default">Ooooups! Looks like you have not fill up details about
          yourself.</h4>
        <a class="btn btn-primary my-3" [routerLink]="['/employee/profile']">Fill up
          Details</a>
      </div>
    </div>
  </div>
  <div *ngIf="profile">
    <app-employee-view [profile]="profile" [moreProfile]="false" [showOther]="false" [showPreference]="false">
    </app-employee-view>
  </div>
  <div *ngIf="queryResult.items" class="table-responsive">

    <table class="table align-items-center table-hover">
      <colgroup>
        <col style="width: 10%">
        <col style="width: 10%">
        <col style="width: 10%">
        <col style="width: 20%">
        <col style="width: 20%">
        <col style="width: 10%">
      </colgroup>
      <thead class="table-light">
        <tr>
          <th *ngFor="let c of columns">
            <div *ngIf="c.isSortable">
              <div class="d-flex justify-content-between align-items-center">
                {{ c.title }}
              </div>
            </div>
            <div *ngIf="!c.isSortable">
              {{ c.title }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let v of queryResult.items; let i=index;">
          <td>{{ v.appNo }}</td>
          <td>{{ v.financialYear?.name }}</td>
          <td>{{ v.phase?.name }}</td>
          <td>{{ v.isTransfer ? 'YES' : 'NO' }}</td>
          <td>
            <ng-container *ngIf="isConfirmButtonDisplay(v)">
              <span *ngIf="v.isConfirm" class="badge bg-success text-white">Locked</span>
              <span *ngIf="!v.isConfirm" class="badge bg-danger text-white">Not Locked</span>
              <a *ngIf="v.isConfirm" class="btn btn-warning btn-sm ml-2"
                [routerLink]="['/employee/transfer-request/unlock']">Unlock</a>
              <a *ngIf="!v.isConfirm" class="btn btn-warning btn-sm ml-2"
                [routerLink]="['/employee/transfer-request/view']">Lock Now</a>
            </ng-container>
            <!-- <a *ngIf="isResultButtonDisplay(v)" class="btn btn-success btn-sm ml-2"
              [routerLink]="['/employee/merit']">Result</a> -->
          </td>
          <td *ngIf="v.financialYearId == financialyearId">
            <a *ngIf="v.isConfirm" target="_blank" class="btn btn-primary btn-sm" (click)="print(v.id)">Print</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
</section>
